<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Author-tp">David and Stephen Isaacs</p>
<p class="Title-tp"><span class="red"><img alt="" class="_idGenObjectAttribute-3" role="presentation" src="image/1.jpg"/></span><span class="red"> <br/></span><span class="green"><img alt="" class="_idGenObjectAttribute-4" role="presentation" src="image/2.jpg"/></span> <br/><span class="orange"><img alt="" class="_idGenObjectAttribute-5" role="presentation" src="image/3.jpg"/></span><br/><span class="blue"><img alt="" class="_idGenObjectAttribute-6" role="presentation" src="image/4.jpg"/></span></p>
<div class="_idGenObjectLayout-1">
<div class="Imprint" id="_idContainer006">
<img alt="" class="_idGenObjectAttribute-7" role="presentation" src="image/Logo-for-titlepages-new-CMYK.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035845781_EPUB2.vue?68c0e9a5